module.exports = __webpack_public_path__ + "static/media/animated_check_mark.fe52ccb7.gif";